<template>
  <div class="customBox" v-if="visible">
    <!-- 弹窗组件 -->
    <el-dialog modal-append-to-body :modal="false" :visible.sync="visible" width="520px" :before-close="handleClose" destroy-on-close
      custom-class="dialog-container">
      <div slot="title" class="dialog-title">
         {{title}}
      </div>
      <div class="content">
        {{content}}
      </div>
      <span slot="footer" class="dialog-footer">
           <el-button v-if="showCancel" class="btn" @click="handleClose">取消</el-button>
        <el-button type="primary" class="btn" @click="okHandle">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdjustExamRoom',
  props: {
    title: {
      type: String,
      default: '提醒'
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    // 控制弹窗显示隐藏，使用 .sync 修饰符
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
    }
  },
  methods: {
    okHandle() {
      this.$emit('confirm');
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false)
    },
  }
}
</script>

<style lang="less">
.customBox {
  .content {
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    text-align: center;
    padding: 30px 40px;
    padding-bottom: 0;
    max-height: 200px;
    overflow-y: auto;
    line-height: 1.8;
    word-break: break-all;
  }
  .tag-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    width: 411px;
    border: 1px solid #D9D9D9;
    min-height: 32px;
    border-radius: 4px;
    padding: 10px;
  }
  .addIcon {
    font-size: 22px;
    color: #3870F6;
  }

  .dialog-container {
    padding: 0;
    border-radius: 10px;
    overflow: hidden;

    .el-dialog__body {
      padding: 0;
    }
  }

  .el-form-item__content {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .btn {
    width: 100px;
    height: 38px;
  }

  .el-dialog__footer {
    text-align: center;
    margin: 40px 0px;
  }

  .el-dialog__header {
    padding: 0;
  }

  .dialog-footer {
    text-align: center;
  }

  .dialog-title {
    padding: 20px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: #333;
    background: #F2F2F2;
  }
}
</style>